<!-- .block-gallery -->
<div *ngIf="item">

    <div class="block-gallery">
        <div class="gallery-main" (click)="showGallery('ddd')">
            <img [src]="item?.image?.url" class="gallery-image">
            <div class="gallery-content flex flex-col justify-center text-center">
                <div class="gallery-title h3">
                    {{translateHelper.localize(item?.title)}}
                </div>
                <div class="gallery-description">
                    {{translateHelper.localize(item?.description)}}
                </div>
            </div>
        </div>
    </div>
</div>
<!-- .block-gallery / end -->
